module.exports = __webpack_public_path__ + "img/vr_m_2.a20293da.jpg";